// removed by extract-text-webpack-plugin
module.exports = {"body":"style__body___3GpIi","container":"style__container___3ZVSy"};


/*****************
 ** WEBPACK FOOTER
 ** ./app/containers/style.scss
 ** module id = 369
 ** module chunks = 0
 **/